import { useState } from 'react';
import { Alert, Col, Container, Form, Image, Row } from "react-bootstrap";
import { FormikErrors, useFormik } from 'formik';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faTiktok,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";
import logo from '../assets/images/logo_white.png';
import './footer.scss';
import { useSelector } from 'react-redux';
import { selectIsMobileRoute } from '../features/mobile/mobileSlice';


interface FormValues {
  subscribeEmail: string;
}

export default function Footer() {
  const [successMsg, setSuccessMsg] = useState('');
  const AppURL = useSelector(selectIsMobileRoute);
  const QURLParams = AppURL ? `/?${AppURL}` : '/';
  const AndURLParams = AppURL ? `&${AppURL}` : '';
  const validate = (values: FormValues) => {
    let errors: FormikErrors<FormValues> = {};
    if (!values.subscribeEmail) {
      errors.subscribeEmail = "Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.subscribeEmail)) {
      errors.subscribeEmail = "Invalid email address";
    }
    return errors;
  }

  const formik = useFormik({
    initialValues: {
      subscribeEmail: '',
    },
    validate,
    onSubmit: (values, { resetForm }) => {
      console.log(values);
      setSuccessMsg('Thank you for subscribing!');

      setTimeout(() => {
        setSuccessMsg('');
      }, 5000);

      resetForm();
    }
  });

  return (
    <footer className='footer bg-black text-white'>
      <div className='footer-max-width'>
        <Row className='mb-5 mx-2'>
          <Col sm={12} md={3} className='text-center'>
            <Link
              to={`${QURLParams}`}
            >
              <Image
                className='footer-logo'
                src={logo}
                loading="lazy"
                alt="MightyMeals Logo"
                width="159"
                height="169"
              />
            </Link>
          </Col>

          <Col sm={12} md={9} lg={6}>
            <Row>

              <Col sm={6} md={3} className='d-flex flex-column footer-column'>
                <div className='mb-md-4 flex-shrink-1'>
                  <h1 className='heading'>GET STARTED</h1>
                </div>
                <div className='font-barlow fs-17px'>
                  <div className='mb-1'>
                    <Link
                      to={`/order${QURLParams}`}
                      className='text-white'
                    >
                      Menu
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/how-it-works${QURLParams}`}
                      className='text-white'
                    >
                      How it Works
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/concierge${QURLParams}`}
                      className='text-white'
                    >
                      Concierge
                    </Link>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://mightymeals.freshdesk.com/support/solutions/61000048924"
                      rel="noreferrer"
                      className='text-white'
                      target='_blank'
                    >
                      FAQ
                    </a>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/catering${QURLParams}`}
                      className='text-white'
                    >
                      Catering
                    </Link>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://mightymeals.freshdesk.com/support/home"
                      rel="noreferrer"
                      className='text-white'
                      target='_blank'
                    >
                      Help
                    </a>
                  </div>
                </div>
              </Col>

              <Col sm={6} md={3} className='d-flex flex-column footer-column'>
                <div className='mb-md-4 flex-shrink-1'>
                  <h1 className='heading'>ABOUT</h1>
                </div>
                <div className='font-barlow fs-17px'>
                  <div className='mb-1'>
                    <Link
                      to={`/our-mission${QURLParams}`}
                      className='text-white'
                    >
                      Who We Are
                    </Link>
                  </div>
                  <div className='my-1'>
                    <a
                      href={`${process.env.REACT_APP_BLOG_URL}`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      Blog
                    </a>
                  </div>
                  <div className='my-1'>
                    <a
                      href={`${process.env.REACT_APP_BLOG_URL}/press`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      Press
                    </a>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://mightymeals.bamboohr.com/jobs/"
                      rel="noreferrer"
                      target="_blank"
                      className='text-white'
                    >
                      Careers
                    </a>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/sustainability${QURLParams}`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      Sustainability
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/enterprise-partnerships${QURLParams}`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      Enterprise Partnerships
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/affiliate-partnerships${QURLParams}`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      Affiliate Partnerships
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/mightyfit-partnerships${QURLParams}`}
                      rel="noreferrer"
                      className='text-white'
                    >
                      MightyFit Partnerships
                    </Link>
                  </div>
                </div>
              </Col>

              <Col sm={6} md={3} className='d-flex flex-column footer-column'>
                <div className='mb-md-4 flex-shrink-1'>
                  <h1 className='heading'>FEATURES</h1>
                </div>
                <div className='font-barlow fs-17px'>
                  <div className='mb-1'>
                    <Link
                      to={`/autoship/orders${QURLParams}`}
                      className='text-white'
                    >
                      Order Planner
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/rewards-program${QURLParams}`}
                      className='text-white'
                    >
                      Rewards Program
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/my-account/refer-a-friend${QURLParams}`}
                      className='text-white'
                    >
                      Give $100 Get $50
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/order/?product_type=gift-card${AndURLParams}`}
                      className='text-white'
                    >
                      Gift Cards
                    </Link>
                  </div>
                  <div className='my-1'>
                    <Link
                      to={`/nutrition${QURLParams}`}
                      className='text-white'
                    >
                      Nutritional Team
                    </Link>
                  </div>
                </div>
              </Col>

              <Col sm={6} md={3} className='d-flex flex-column footer-column'>
                <div className='mb-md-4 flex-shrink-1'>
                  <h1 className='heading'>FOLLOW US</h1>
                </div>
                <div className='font-barlow fs-17px'>
                  <div className='mb-1'>
                    <a
                      href="https://instagram.com/eatmightymeals"
                      rel="noreferrer"
                      target="_blank"
                      className='text-white d-inline-flex align-align-items-center'
                    >
                      <span className='f-social'>
                        <FontAwesomeIcon
                          icon={faInstagram}
                        />
                      </span>Instagram
                    </a>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://www.tiktok.com/discover/mighty-meals"
                      rel="noreferrer"
                      target="_blank"
                      className='text-white d-inline-flex align-align-items-center'
                    >
                      <span className='f-social'>
                        <FontAwesomeIcon
                          icon={faTiktok}
                        />
                      </span>TikTok
                    </a>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://www.facebook.com/EatMightyMeals/"
                      rel="noreferrer"
                      target="_blank"
                      className='text-white d-inline-flex align-align-items-center'
                    >
                      <span className='f-social'>
                        <FontAwesomeIcon
                          icon={faFacebookF}
                        />
                      </span>Facebook
                    </a>
                  </div>
                  <div className='my-1'>
                    <a
                      href="https://twitter.com/MightyMealsVA"
                      rel="noreferrer"
                      target="_blank"
                      className='text-white d-inline-flex align-align-items-center'
                    >
                      <span className='f-social'>
                        <FontAwesomeIcon
                          icon={faTwitter}
                        />
                      </span>Twitter
                    </a>
                  </div>
                </div>
              </Col>

            </Row>
          </Col>

          <Col sm={12} lg={3} className='mt-1'>
            <Form className='login-form' onSubmit={formik.handleSubmit}>
              {successMsg &&
                <Alert variant='success'>{successMsg}</Alert>
              }
              <div className="klaviyo-form-R7yPQN"></div>
            </Form>
          </Col>

        </Row>
      </div>
      <Container fluid className='mt-5'>
        <hr />
      </Container>
      <div className='footer-max-width'>
        <Row className='d-flex align-items-center'>
          <Col md={7}>
            <div className='d-flex flex-wrap font-barlow fs-18'>
              MightyMeals INC | 7669 Limestone Drive Suite 130, Gainesville, VA 20155 | (833) 406-3257
              <span className='d-none d-md-inline-block' >|</span> <a className='text-white d-inline-block ms-1' href="mailto:info@eatmightymeals.com">info@eatmightymeals.com</a>
            </div>
            <div className='d-flex flex-wrap font-barlow fs-18 mt-2'>
              <Link
                to={`/terms-and-conditions${QURLParams}`}
                className='text-white'
              >
                Terms &amp; Conditions
              </Link>&nbsp;|&nbsp;
              <a
                href="https://mightymeals.freshdesk.com/support/solutions/folders/61000201298"
                rel="noreferrer"
                target="_blank"
                className='text-white'
              >
                Shipping Delivery Terms
              </a>&nbsp;|&nbsp;
              <Link
                to={`/terms-and-conditions#privacy${QURLParams}`}
                className='text-white'
              >
                Privacy Policy
              </Link>&nbsp;|&nbsp;
              <Link
                to={`/terms-and-conditions#refunds${QURLParams}`}
                className='text-white'
              >
                Returns Policy
              </Link>&nbsp;|&nbsp;
              <Link
                to={`/terms-and-conditions#refunds${QURLParams}`}
                className='text-white'
              >
                Refund Policy
              </Link>

            </div>
          </Col>
          {!AppURL.includes('utm_source') &&
            <Col md={5} className='d-flex flex-wrap justify-md-content-end justify-content-center py-2'>
              <div className='p-2'>
                <a href='https://play.google.com/store/apps/details?id=com.mightymeals.app&hl=en_US&gl=US' target='_blank' rel="noreferrer">
                  <svg width="168" height="49" viewBox="0 0 168 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.32227 0.866028H161.677C164.689 0.866028 167.124 3.27089 167.124 6.22967V42.4977C167.124 45.4565 164.689 47.8614 161.677 47.8614H6.32227C3.31033 47.8614 0.875 45.4565 0.875 42.4977V6.22967C0.875 3.27089 3.31033 0.866028 6.32227 0.866028Z" fill="black" stroke="white" strokeWidth="0.5" />
                    <path d="M84.7487 26.6457C81.8306 26.6457 79.4451 28.8364 79.4451 31.8486C79.4451 34.8608 81.8229 37.0515 84.7487 37.0515C87.6745 37.0515 90.0523 34.8456 90.0523 31.8486C90.0523 28.8516 87.6745 26.6457 84.7487 26.6457ZM84.7487 35.0053C83.1507 35.0053 81.7688 33.7046 81.7688 31.8486C81.7688 29.9926 83.1507 28.6919 84.7487 28.6919C86.3467 28.6919 87.7286 29.9698 87.7286 31.8486C87.7286 33.7274 86.3467 35.0053 84.7487 35.0053ZM73.1843 26.6457C70.2662 26.6457 67.8808 28.8364 67.8808 31.8486C67.8808 34.8608 70.2585 37.0515 73.1843 37.0515C76.1102 37.0515 78.4879 34.8456 78.4879 31.8486C78.4879 28.8516 76.1102 26.6457 73.1843 26.6457ZM73.1843 35.0053C71.5863 35.0053 70.2045 33.7046 70.2045 31.8486C70.2045 29.9926 71.5863 28.6919 73.1843 28.6919C74.7823 28.6919 76.1642 29.9698 76.1642 31.8486C76.1642 33.7274 74.7823 35.0053 73.1843 35.0053ZM59.4275 28.2431V30.449H64.7851C64.623 31.6889 64.2061 32.5941 63.5654 33.2254C62.7856 33.9937 61.5659 34.838 59.4275 34.838C56.1234 34.838 53.545 32.2137 53.545 28.9657C53.545 25.7177 56.1234 23.0935 59.4275 23.0935C61.2108 23.0935 62.5077 23.7857 63.465 24.668L65.0476 23.1087C63.7043 21.846 61.9287 20.88 59.4275 20.88C54.9037 20.88 51.1055 24.5083 51.1055 28.9581C51.1055 33.408 54.9037 37.0363 59.4275 37.0363C61.867 37.0363 63.712 36.2452 65.1479 34.7695C66.6301 33.3091 67.0856 31.2629 67.0856 29.6047C67.0856 29.095 67.047 28.6158 66.9621 28.2279H59.4198L59.4275 28.2431ZM115.682 29.9546C115.242 28.7908 113.899 26.6457 111.158 26.6457C108.418 26.6457 106.179 28.7528 106.179 31.8486C106.179 34.7619 108.418 37.0515 111.421 37.0515C113.845 37.0515 115.242 35.591 115.821 34.7467L114.022 33.5677C113.42 34.4348 112.602 35.0053 111.421 35.0053C110.24 35.0053 109.398 34.4729 108.858 33.4308L115.922 30.5555L115.682 29.9622V29.9546ZM108.48 31.6889C108.418 29.6807 110.062 28.6539 111.243 28.6539C112.162 28.6539 112.942 29.1103 113.204 29.7568L108.487 31.6889H108.48ZM102.736 36.732H105.06V21.4352H102.736V36.732ZM98.9378 27.8019H98.8606C98.3434 27.1934 97.3398 26.6381 96.0815 26.6381C93.4413 26.6381 91.0172 28.9277 91.0172 31.8638C91.0172 34.8 93.4413 37.0439 96.0815 37.0439C97.3398 37.0439 98.3434 36.4886 98.8606 35.8649H98.9378V36.6103C98.9378 38.6032 97.8571 39.6682 96.1201 39.6682C94.6996 39.6682 93.8196 38.6641 93.4567 37.8122L91.4341 38.6413C92.0131 40.0181 93.5571 41.7143 96.1124 41.7143C98.8298 41.7143 101.13 40.1398 101.13 36.2908V26.95H98.9301V27.7943L98.9378 27.8019ZM96.2745 34.9977C94.6765 34.9977 93.3332 33.6742 93.3332 31.8638C93.3332 30.0535 94.6765 28.6919 96.2745 28.6919C97.8725 28.6919 99.0922 30.0307 99.0922 31.8638C99.0922 33.697 97.8493 34.9977 96.2745 34.9977ZM126.544 21.4352H120.994V36.732H123.309V30.9358H126.544C129.115 30.9358 131.639 29.1027 131.639 26.1893C131.639 23.276 129.115 21.4428 126.544 21.4428V21.4352ZM126.606 28.806H123.309V23.5651H126.606C128.335 23.5651 129.323 24.9799 129.323 26.1893C129.323 27.3988 128.343 28.8136 126.606 28.8136V28.806ZM140.926 26.6077C139.251 26.6077 137.514 27.3379 136.796 28.9505L138.85 29.7948C139.29 28.9505 140.108 28.6767 140.965 28.6767C142.161 28.6767 143.381 29.3841 143.404 30.6468V30.8065C142.987 30.5707 142.084 30.2132 140.988 30.2132C138.772 30.2132 136.518 31.415 136.518 33.659C136.518 35.7051 138.332 37.0211 140.37 37.0211C141.93 37.0211 142.787 36.3289 143.327 35.5226H143.404V36.7016H145.643V30.8369C145.643 28.1214 143.59 26.6077 140.934 26.6077H140.926ZM140.648 34.9901C139.892 34.9901 138.834 34.6174 138.834 33.6894C138.834 32.5104 140.154 32.054 141.289 32.054C142.308 32.054 142.787 32.267 143.404 32.5636C143.227 33.9785 141.984 34.9825 140.648 34.9825V34.9901ZM153.788 26.9424L151.132 33.5753H151.055L148.299 26.9424H145.805L149.935 36.2072L147.581 41.3644H149.997L156.366 26.9424H153.788ZM132.921 36.7244H135.237V21.4276H132.921V36.7244Z" fill="white" />
                    <path d="M13.1006 9.26476C12.7377 9.63749 12.5293 10.2232 12.5293 10.9838V38.0175C12.5293 38.7782 12.7455 39.3563 13.1006 39.7366L13.1932 39.8279L28.5635 24.6833V24.3257L13.1932 9.18109L13.1006 9.27237V9.26476Z" fill="#5BC9F4" />
                    <path d="M33.6895 29.7341L28.5635 24.6833V24.3258L33.6895 19.2751L33.8053 19.3435L39.8731 22.7437C41.6101 23.7173 41.6101 25.2995 39.8731 26.2731L33.8053 29.6732L33.6895 29.7417V29.7341Z" fill="url(#paint0_linear_2586_173)" />
                    <path d="M33.8053 29.6656L28.5635 24.5007L13.1006 39.7367C13.6719 40.33 14.6137 40.406 15.679 39.8127L33.8053 29.6656Z" fill="url(#paint1_linear_2586_173)" />
                    <path d="M33.8053 19.3358L15.679 9.18866C14.6137 8.59535 13.6719 8.66381 13.1006 9.26473L28.5635 24.5007L33.8053 19.3358Z" fill="url(#paint2_linear_2586_173)" />
                    <path d="M57.0733 10.1318C56.6101 9.72109 55.9925 9.46247 55.3131 9.46247C53.7846 9.46247 52.6112 10.7023 52.6112 12.2313C52.6112 13.7602 53.7846 14.9848 55.3131 14.9848C56.6255 14.9848 57.5828 14.2318 57.6445 13.0452H55.5679V12.2008H58.7717C58.7717 14.7262 57.4052 15.9204 55.3131 15.9204C53.2211 15.9204 51.623 14.2698 51.623 12.2313C51.623 10.1927 53.2365 8.53447 55.3131 8.53447C56.2781 8.53447 57.1505 8.89958 57.7835 9.48529L57.0733 10.1318Z" fill="white" />
                    <path d="M64.4383 8.61818V9.52336H61.0956V11.8205H64.0137V12.7333H61.0956V14.9088H64.5386V15.814H60.1074V8.61818H64.4306H64.4383Z" fill="white" />
                    <path d="M70.8304 8.61818V9.53857H68.6148V15.814H67.6189V9.53857H65.4033V8.61818H70.8304Z" fill="white" />
                    <path d="M75.5624 8.61818V15.814H74.5742V8.61818H75.5624Z" fill="white" />
                    <path d="M82.2864 8.61818V9.53857H80.0708V15.814H79.075V9.53857H76.8594V8.61818H82.2864Z" fill="white" />
                    <path d="M89.2423 8.53452C91.3344 8.53452 92.9556 10.1851 92.9556 12.2313C92.9556 14.2775 91.3344 15.9205 89.2423 15.9205C87.1503 15.9205 85.5522 14.2699 85.5522 12.2313C85.5522 10.1927 87.1657 8.53452 89.2423 8.53452ZM89.2423 14.9773C90.7786 14.9773 91.9597 13.7526 91.9597 12.2313C91.9597 10.71 90.7863 9.47012 89.2423 9.47012C87.6984 9.47012 86.5404 10.7024 86.5404 12.2313C86.5404 13.7602 87.7138 14.9773 89.2423 14.9773Z" fill="white" />
                    <path d="M98.7837 15.814L95.4564 10.3905V15.814H94.4683V8.61818H95.441L98.7374 13.996V8.61818H99.7255V15.814H98.7837Z" fill="white" />
                    <defs>
                      <linearGradient id="paint0_linear_2586_173" x1="38.746" y1="24.5008" x2="8.72339" y2="24.5008" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#FEE000" />
                        <stop offset="0.42" stopColor="#FBBC0E" />
                        <stop offset="0.78" stopColor="#F9A318" />
                        <stop offset="1" stopColor="#F99B1C" />
                      </linearGradient>
                      <linearGradient id="paint1_linear_2586_173" x1="30.9567" y1="27.3076" x2="3.14253" y2="55.5361" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#EF4547" />
                        <stop offset="1" stopColor="#C6186D" />
                      </linearGradient>
                      <linearGradient id="paint2_linear_2586_173" x1="2.59383" y1="-6.24504" x2="25.3045" y2="16.804" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#279E6F" />
                        <stop offset="0.04" stopColor="#2B9F6E" />
                        <stop offset="0.46" stopColor="#52B16B" />
                        <stop offset="0.8" stopColor="#6BBC69" />
                        <stop offset="1" stopColor="#74C169" />
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </div>
              <div className='p-2'>
                <a href='https://apps.apple.com/us/app/mightymeals/id6451319843' target='_blank' rel="noreferrer">
                  <svg width="168" height="49" viewBox="0 0 168 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.74 0.25H162.26C165.291 0.25 167.75 2.71543 167.75 5.75839V42.9616C167.75 46.0046 165.291 48.47 162.26 48.47H5.74C2.70871 48.47 0.25 46.0046 0.25 42.9616V5.75839C0.25 2.71543 2.70871 0.25 5.74 0.25Z" fill="black" stroke="white" strokeWidth="0.5" />
                    <path d="M55.7199 13.5769L55.0122 15.9021H53.4722L56.0933 7.6937H57.9988L60.6588 15.9021H59.0566L58.3177 13.5769H55.7199ZM58.0611 12.4455L57.4155 10.4246C57.2599 9.92526 57.1277 9.36347 57.0033 8.88751H56.9799C56.8555 9.36347 56.7388 9.93307 56.5911 10.4246L55.9611 12.4455H58.0611Z" fill="white" />
                    <path d="M62.8912 9.97203L63.8479 12.9839C64.019 13.5066 64.1357 13.9826 64.2524 14.4664H64.2913C64.4001 13.9826 64.5324 13.5145 64.6957 12.9839L65.6446 9.97203H67.2079L64.9524 15.9021H63.4824L61.2812 9.97203H62.899H62.8912Z" fill="white" />
                    <path d="M73.1573 14.4819C73.1573 15.0203 73.1807 15.5431 73.2507 15.9098H71.9051L71.7962 15.2544H71.7573C71.4073 15.7147 70.7851 16.0425 70.0073 16.0425C68.8173 16.0425 68.1484 15.1764 68.1484 14.2791C68.1484 12.7965 69.4707 12.0241 71.6562 12.0397V11.946C71.6562 11.5559 71.5007 10.9083 70.4507 10.9083C69.8673 10.9083 69.2607 11.0878 68.864 11.3452L68.5762 10.3699C69.0118 10.1046 69.7818 9.84712 70.7151 9.84712C72.6129 9.84712 73.1573 11.0565 73.1573 12.3596V14.4897V14.4819ZM71.7029 13.0072C70.6451 12.9916 69.6418 13.2179 69.6418 14.1152C69.6418 14.7004 70.0151 14.9657 70.4896 14.9657C71.0962 14.9657 71.524 14.5756 71.664 14.1464C71.7029 14.0372 71.7029 13.9279 71.7029 13.8187V12.9994V13.0072Z" fill="white" />
                    <path d="M76.0119 9.12174C75.5142 9.12174 75.1875 8.75501 75.1875 8.31806C75.1875 7.8577 75.5297 7.49878 76.0275 7.49878C76.5253 7.49878 76.8519 7.8499 76.8675 8.31806C76.8675 8.75501 76.5408 9.12174 76.0275 9.12174H76.0119ZM75.2731 15.9023V9.97223H76.7664V15.9023H75.2731Z" fill="white" />
                    <path d="M78.9131 7.24899H80.4064V15.91H78.9131V7.24899Z" fill="white" />
                    <path d="M87.1578 14.4819C87.1578 15.0203 87.1811 15.5431 87.2511 15.9098H85.9056L85.7967 15.2544H85.7578C85.4078 15.7147 84.7856 16.0425 84.0078 16.0425C82.8178 16.0425 82.1489 15.1764 82.1489 14.2791C82.1489 12.7965 83.4711 12.0241 85.6567 12.0397V11.946C85.6567 11.5559 85.5011 10.9083 84.4589 10.9083C83.8756 10.9083 83.2689 11.0878 82.8723 11.3452L82.5845 10.3699C83.02 10.1046 83.79 9.84712 84.7234 9.84712C86.6134 9.84712 87.1656 11.0565 87.1656 12.3596V14.4897L87.1578 14.4819ZM85.7034 13.0072C84.6456 12.9916 83.6423 13.2179 83.6423 14.1152C83.6423 14.7004 84.0156 14.9657 84.49 14.9657C85.0967 14.9657 85.5245 14.5756 85.6645 14.1464C85.7034 14.0372 85.7034 13.9279 85.7034 13.8187V12.9994V13.0072Z" fill="white" />
                    <path d="M89.2655 7.24899H90.7588V10.7914H90.7821C91.1477 10.2218 91.7932 9.83949 92.6799 9.83949C94.1266 9.83949 95.1532 11.0489 95.1455 12.8513C95.1455 14.9815 93.7999 16.0426 92.4621 16.0426C91.6999 16.0426 91.0155 15.7461 90.5955 15.0205H90.5721L90.5021 15.91H89.2266C89.2499 15.5042 89.2732 14.8488 89.2732 14.2558V7.24899H89.2655ZM90.7588 13.4599C90.7588 13.5848 90.7743 13.7018 90.7977 13.8111C90.9532 14.4197 91.4743 14.8566 92.1199 14.8566C93.0532 14.8566 93.6288 14.1154 93.6288 12.9059C93.6288 11.8604 93.131 11.0099 92.1354 11.0099C91.5288 11.0099 90.9688 11.4468 90.8132 12.1023C90.7899 12.2115 90.7666 12.3441 90.7666 12.4924V13.4521L90.7588 13.4599Z" fill="white" />
                    <path d="M96.9033 7.24899H98.3967V15.91H96.9033V7.24899Z" fill="white" />
                    <path d="M101.609 13.3586C101.648 14.4275 102.48 14.8957 103.429 14.8957C104.121 14.8957 104.603 14.7865 105.07 14.6304L105.288 15.6526C104.774 15.871 104.074 16.0271 103.227 16.0271C101.306 16.0271 100.178 14.8489 100.178 13.0309C100.178 11.3845 101.173 9.83955 103.071 9.83955C104.969 9.83955 105.622 11.4235 105.622 12.7265C105.622 13.0074 105.599 13.2259 105.576 13.3586H101.617H101.609ZM104.207 12.313C104.222 11.7668 103.973 10.8617 102.978 10.8617C102.052 10.8617 101.663 11.7044 101.609 12.313H104.207Z" fill="white" />
                    <path d="M112.988 16.0427C111.323 16.0427 110.024 14.8957 110.024 12.984C110.024 11.0724 111.3 9.83955 113.081 9.83955C114.862 9.83955 116.021 11.0802 116.021 12.8826C116.021 15.0596 114.489 16.0349 112.996 16.0349H112.98L112.988 16.0427ZM113.034 14.9581C113.882 14.9581 114.481 14.131 114.481 12.9216C114.481 11.9931 114.069 10.9241 113.05 10.9241C112.031 10.9241 111.564 11.9619 111.564 12.945C111.564 14.092 112.132 14.9581 113.019 14.9581H113.034Z" fill="white" />
                    <path d="M117.779 11.7432C117.779 11.0643 117.755 10.4869 117.732 9.97977H119.031L119.101 10.8693H119.14C119.404 10.4089 120.05 9.84712 121.037 9.84712C122.025 9.84712 123.137 10.5182 123.137 12.3908V15.9098H121.644V12.5625C121.644 11.712 121.325 11.0643 120.516 11.0643C119.925 11.0643 119.513 11.4935 119.35 11.9382C119.303 12.0631 119.28 12.2425 119.28 12.4142V15.9098H117.786V11.7432H117.779Z" fill="white" />
                    <path d="M130.013 8.45054V9.97206H131.436V11.0956H130.013V13.7017C130.013 14.4352 130.208 14.7941 130.775 14.7941C131.04 14.7941 131.188 14.7785 131.359 14.7317L131.382 15.8631C131.164 15.9489 130.76 16.0191 130.301 16.0191C129.741 16.0191 129.298 15.8397 129.018 15.5354C128.691 15.1921 128.543 14.6459 128.543 13.8656V11.0878H127.703V9.96426H128.543V8.85628L130.013 8.44273V8.45054Z" fill="white" />
                    <path d="M133.093 7.24899H134.587V10.7836H134.61C134.789 10.5027 135.045 10.2686 135.349 10.1126C135.652 9.94092 136.002 9.84729 136.383 9.84729C137.387 9.84729 138.444 10.5183 138.444 12.4144V15.91H136.951V12.5704C136.951 11.7199 136.632 11.0567 135.808 11.0567C135.224 11.0567 134.812 11.4468 134.641 11.8994C134.594 12.032 134.579 12.1959 134.579 12.352V15.91H133.085V7.24899H133.093Z" fill="white" />
                    <path d="M141.625 13.3586C141.664 14.4275 142.497 14.8957 143.445 14.8957C144.138 14.8957 144.62 14.7865 145.087 14.6304L145.304 15.6526C144.791 15.871 144.091 16.0271 143.243 16.0271C141.322 16.0271 140.194 14.8489 140.194 13.0309C140.194 11.3845 141.19 9.83955 143.088 9.83955C144.985 9.83955 145.639 11.4235 145.639 12.7265C145.639 13.0074 145.615 13.2259 145.592 13.3586H141.633H141.625ZM144.223 12.313C144.239 11.7668 143.99 10.8617 142.994 10.8617C142.069 10.8617 141.68 11.7044 141.625 12.313H144.223Z" fill="white" />
                    <path d="M37.1467 23.8684C37.1078 19.8032 40.46 17.8291 40.6155 17.7355C38.7178 14.9578 35.77 14.5754 34.7355 14.5442C32.2622 14.2867 29.8667 16.0267 28.6067 16.0267C27.3467 16.0267 25.3789 14.5676 23.2944 14.6066C20.6033 14.6535 18.0911 16.214 16.7067 18.6328C13.86 23.5797 15.9833 30.844 18.7133 34.8468C20.0822 36.8053 21.6767 38.99 23.7611 38.912C25.7989 38.8262 26.5611 37.609 29.0267 37.609C31.4922 37.609 32.1844 38.912 34.3155 38.8652C36.5089 38.8262 37.8855 36.8989 39.2 34.9248C40.7789 32.6777 41.4089 30.4695 41.44 30.3603C41.3855 30.3447 37.1855 28.7373 37.1389 23.8606" fill="white" />
                    <path d="M33.1177 11.9224C34.2143 10.5414 34.9688 8.66872 34.7588 6.76486C33.1721 6.83509 31.181 7.86504 30.0377 9.21491C29.0266 10.4009 28.1166 12.3516 28.3499 14.1774C30.1388 14.3101 31.9666 13.2723 33.1177 11.9146" fill="white" />
                    <path d="M66.6559 38.5995H63.8093L62.2537 33.6838H56.8404L55.3548 38.5995H52.5859L57.9526 21.8705H61.2659L66.6559 38.5995ZM61.7871 31.6239L60.3793 27.2544C60.2315 26.8096 59.9515 25.7563 59.5393 24.1021H59.4926C59.3293 24.8122 59.0648 25.8655 58.6993 27.2544L57.3148 31.6239H61.7948H61.7871Z" fill="white" />
                    <path d="M80.4615 32.4201C80.4615 34.4722 79.9093 36.0952 78.8048 37.2812C77.817 38.3423 76.5881 38.8651 75.1181 38.8651C73.5315 38.8651 72.3959 38.2955 71.7037 37.1563H71.657V43.5077H68.9815V30.5006C68.9815 29.2132 68.9504 27.8867 68.8804 26.5291H71.2293L71.377 28.4407H71.4315C72.3181 26.9972 73.6715 26.2794 75.4837 26.2794C76.8993 26.2794 78.0893 26.8412 79.0304 27.9648C79.9793 29.0884 80.4537 30.5709 80.4537 32.4045M77.7315 32.5059C77.7315 31.3355 77.467 30.3602 76.9381 29.6033C76.3626 28.8075 75.5848 28.4095 74.6126 28.4095C73.9515 28.4095 73.3526 28.628 72.8159 29.0649C72.2793 29.5097 71.9293 30.0793 71.7659 30.7893C71.6804 31.1249 71.6415 31.3901 71.6415 31.6086V33.6217C71.6415 34.4956 71.9059 35.2369 72.4426 35.8377C72.9793 36.4463 73.6793 36.7428 74.5348 36.7428C75.5381 36.7428 76.3237 36.3605 76.8837 35.5802C77.4437 34.7999 77.7237 33.7778 77.7237 32.4981" fill="white" />
                    <path d="M94.2901 32.4201C94.2901 34.4722 93.7379 36.0952 92.6335 37.2812C91.6457 38.3423 90.4168 38.8651 88.9468 38.8651C87.3679 38.8651 86.2246 38.2955 85.5323 37.1563H85.4857V43.5077H82.8179V30.5006C82.8179 29.2132 82.7868 27.8867 82.7168 26.5291H85.0657L85.2135 28.4407H85.2679C86.1546 26.9972 87.5079 26.2794 89.3201 26.2794C90.7357 26.2794 91.9179 26.8412 92.8668 27.9648C93.8157 29.0884 94.2901 30.5709 94.2901 32.4045M91.5679 32.5059C91.5679 31.3355 91.3035 30.3602 90.7746 29.6033C90.199 28.8075 89.4212 28.4095 88.449 28.4095C87.7879 28.4095 87.189 28.628 86.6524 29.0649C86.1157 29.5097 85.7657 30.0793 85.6024 30.7893C85.5168 31.1249 85.4779 31.3901 85.4779 31.6086V33.6217C85.4779 34.4956 85.7423 35.2369 86.279 35.8377C86.8157 36.4463 87.5079 36.7428 88.3712 36.7428C89.3746 36.7428 90.1601 36.3605 90.7201 35.5802C91.2801 34.7999 91.5601 33.7778 91.5601 32.4981" fill="white" />
                    <path d="M109.753 33.9104C109.753 35.3305 109.263 36.4931 108.267 37.3826C107.178 38.3579 105.669 38.8495 103.725 38.8495C101.928 38.8495 100.489 38.5062 99.4004 37.8117L100.023 35.5801C101.197 36.2902 102.48 36.6491 103.888 36.6491C104.892 36.6491 105.677 36.4228 106.237 35.9703C106.797 35.5099 107.077 34.9013 107.077 34.1444C107.077 33.4656 106.844 32.896 106.385 32.4279C105.926 31.9597 105.156 31.5305 104.083 31.1326C101.166 30.0402 99.7037 28.4407 99.7037 26.334C99.7037 24.9607 100.217 23.8293 101.236 22.9554C102.255 22.0737 103.616 21.6367 105.319 21.6367C106.836 21.6367 108.096 21.902 109.099 22.4326L108.43 24.6174C107.489 24.1024 106.424 23.8449 105.241 23.8449C104.3 23.8449 103.569 24.079 103.04 24.5393C102.597 24.9529 102.371 25.4601 102.371 26.0531C102.371 26.7163 102.628 27.2625 103.134 27.6916C103.577 28.0896 104.386 28.5187 105.56 28.9869C106.992 29.5643 108.049 30.2431 108.726 31.0234C109.403 31.8036 109.737 32.7712 109.737 33.926" fill="white" />
                    <path d="M118.58 28.55H115.64V34.4098C115.64 35.9001 116.161 36.6413 117.203 36.6413C117.678 36.6413 118.075 36.6023 118.386 36.5165L118.456 38.553C117.935 38.7481 117.235 38.8495 116.379 38.8495C115.321 38.8495 114.497 38.5296 113.906 37.882C113.315 37.2343 113.011 36.1498 113.011 34.6282V28.55H111.253V26.5369H113.011V24.3287L115.632 23.5328V26.5369H118.572V28.55H118.58Z" fill="white" />
                    <path d="M131.864 32.4748C131.864 34.3318 131.336 35.8534 130.286 37.0394C129.181 38.2644 127.711 38.873 125.883 38.873C124.056 38.873 122.71 38.2878 121.668 37.1096C120.618 35.9392 120.097 34.4567 120.097 32.6699C120.097 30.7972 120.633 29.2679 121.714 28.0819C122.796 26.8881 124.25 26.2951 126.078 26.2951C127.906 26.2951 129.259 26.8803 130.332 28.0585C131.359 29.2055 131.864 30.6724 131.864 32.4748ZM129.096 32.5606C129.096 31.4526 128.854 30.4929 128.38 29.697C127.82 28.7373 127.019 28.2535 125.984 28.2535C124.95 28.2535 124.094 28.7373 123.534 29.697C123.052 30.4929 122.819 31.4604 122.819 32.6074C122.819 33.7544 123.052 34.6752 123.534 35.471C124.11 36.4308 124.919 36.9145 125.961 36.9145C127.003 36.9145 127.781 36.423 128.357 35.4476C128.854 34.6361 129.096 33.6764 129.096 32.5606Z" fill="white" />
                    <path d="M140.545 28.9012C140.281 28.8543 140.001 28.8309 139.705 28.8309C138.764 28.8309 138.041 29.1899 137.527 29.8999C137.084 30.5319 136.858 31.32 136.858 32.2797V38.6077H134.191L134.214 30.3447C134.214 28.9558 134.183 27.6917 134.113 26.5447H136.438L136.539 28.8543H136.609C136.889 28.0585 137.341 27.4186 137.947 26.9427C138.538 26.5135 139.184 26.2951 139.876 26.2951C140.125 26.2951 140.343 26.3107 140.545 26.3419V28.9012Z" fill="white" />
                    <path d="M152.491 31.9987C152.491 32.4825 152.46 32.8804 152.398 33.2159H144.387C144.418 34.4098 144.807 35.3149 145.546 35.9469C146.223 36.5087 147.094 36.7896 148.167 36.7896C149.349 36.7896 150.43 36.6023 151.41 36.22L151.83 38.0848C150.695 38.5842 149.349 38.8339 147.794 38.8339C145.935 38.8339 144.465 38.2799 143.407 37.1797C142.349 36.0795 141.812 34.6048 141.812 32.7478C141.812 30.8907 142.31 29.416 143.298 28.2066C144.333 26.9192 145.74 26.2715 147.498 26.2715C149.256 26.2715 150.547 26.9192 151.434 28.2066C152.141 29.2366 152.491 30.5006 152.491 32.0065M149.948 31.3121C149.964 30.5162 149.792 29.8296 149.427 29.2522C148.968 28.5109 148.253 28.1364 147.296 28.1364C146.425 28.1364 145.717 28.5031 145.173 29.2288C144.729 29.8062 144.465 30.5006 144.387 31.3121H149.948Z" fill="white" />
                  </svg>
                </a>
              </div>
            </Col>}
        </Row>
      </div>
    </footer>
  )
}